module.exports = __webpack_public_path__ + "static/media/cross.b47341f5.svg";